import { Box, Typography, makeStyles } from "@material-ui/core";
import React, { FC } from "react";

import { CalculatorBody } from "./CalculatorBody";
import { CalculatorFooter } from "./CalculatorFooter";
import { CalculatorHeader } from "./CalculatorHeader";
import MainLayout from "../Layout/MainLayout";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: theme.spacing(2),
    marginBottom: theme.spacing(6),
    maxWidth: theme.widths.calculatorWidth,
  },
}));

export const CalculatorLayout: FC<{ header?: React.ReactNode; footer?: React.ReactNode }> = ({
  children,
  header,
  footer,
}) => {
  const classes = useStyles();
  return (
    <MainLayout>
      <div className={classes.root}>
        <div className={classes.wrapper}>
          {header && <CalculatorHeader>{header}</CalculatorHeader>}
          <CalculatorBody>{children}</CalculatorBody>
          {footer && <CalculatorFooter>{footer}</CalculatorFooter>}
        </div>
      </div>
    </MainLayout>
  );
};
